import React from 'react';

interface FlagProps {
  language: string;
}

const Flag: React.FC<FlagProps> = ({ language }) => {
    const flags = {
      es: '🇪🇸',
      en: '🇺🇸'
    };
    
    return <span className="text-lg">{flags[language as keyof typeof flags]}</span>;
  };

export default Flag;